import React from "react";
import { Modal } from "reactstrap";
import SignInModal from ".";
import SignUpModal from "../SignUp/SignUp";

export const openModalForSignUpUsers = (
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsSignInModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  returnTo?: string
) => {
  if (returnTo) {
    try {
      sessionStorage.setItem('auth_return_to', returnTo);
    } catch (e) {
      // ignore storage errors
    }
  }
  setModalOpen(true);
  setIsSignInModalOpen(true);
};

interface OpenSignUpModalProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  isSignInModalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSignInModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const OpenSignUpModal: React.FC<OpenSignUpModalProps> = ({
  isModalOpen,
  toggleModal,
  isSignInModalOpen,
  setModalOpen,
  setIsSignInModalOpen,
}) => {
  //   const [isModalOpen, setModalOpen] = useState(false);
  //   const [isSignInModalOpen, setIsSignInModalOpen] = useState<boolean>(false);

  //   const toggleModal = () => {
  //     setModalOpen(!isModalOpen);
  //   };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        className="transparent-modal"
        centered
      >
        {isSignInModalOpen ? (
          <SignInModal
            setModalOpen={setModalOpen}
            setIsSignInModalOpen={setIsSignInModalOpen}
          />
        ) : (
          <SignUpModal
            setModalOpen={setModalOpen}
            setIsSignInModal={setIsSignInModalOpen}
          />
        )}
      </Modal>
    </>
  );
};

export default OpenSignUpModal;
